module.exports = __webpack_public_path__ + "img/function-image-send.9cd095a6.svg";